import React from "react";
import PropTypes from "prop-types";
import screenfull from "screenfull";
import Ads from "../../helpers/gamescreen/ads";
import log from "../../helpers/log";
class AnunciosPreJuego extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showLoadingIcon: true,
			segundos: -1
		};

		this.startAd = this.startAd.bind(this);
		this.endAd = this.endAd.bind(this);
		this.moverBarra = this.moverBarra.bind(this);

		this.ads = new Ads(
			this.props.addata,
			this.startAd,
			this.endAd,
			this.moverBarra,
			{
				size_x: this.props.gameInfo.size_x,
				size_y: this.props.gameInfo.size_y
			}
		);
	}
	componentDidMount() {
		this.ads.init();
		//this.startAd();
		//this.moverBarra(9, 10);
	}
	startAd() {
		this.setState({
			showLoadingIcon: false
		});
	}
	endAd() {
		this.props.onFinish();
	}
	moverBarra(segundos, duracion) {
		const porcentajeFragmento = 100 / duracion;
		const porcentajeAvanzado = 100 - Math.abs(porcentajeFragmento * segundos);
		this.setState({
			porcentajeAvanzado,
			segundos: Math.round(segundos)
		});
	}

	render() {
		return (
			<React.Fragment>
				<div
					id="adContainer"
					style={{
						width: this.props.gameInfo.size_x,
						height: this.props.gameInfo.size_y
					}}
				>
					<video id="ad_video" preload="none">
						<source src="/public/video/loading.mp4" />
					</video>
				</div>
				{this.state.showLoadingIcon ? (
					<section className="loading pre-ad">
						<div className="loading-container">
							<img src={this.props.charging_url} />

							<div className="loader">
								<span className="dot dot_1" />
								<span className="dot dot_2" />
								<span className="dot dot_3" />
								<span className="dot dot_4" />
							</div>
						</div>
					</section>
				) : null}
				<div className="GameActions GameActions--ad">
					{this.state.showLoadingIcon || this.state.segundos == -1 ? (
						<span> {this.props.translate.loading_ads}...</span>
					) : (
						<React.Fragment>
							<div className="progress carga-video">
								<div
									className="progress-bar progress-bar-striped active"
									role="progressbar"
									aria-valuenow={this.state.porcentajeAvanzado}
									aria-valuemin="0"
									aria-valuemax="100"
									style={{ width: `${this.state.porcentajeAvanzado}%` }}
								>
									<span>
										{this.state.segundos}{" "}
										{this.state.segundos == 1
											? this.props.translate.segundo
											: this.props.translate.segundos}
									</span>
								</div>
							</div>
						</React.Fragment>
					)}
				</div>
			</React.Fragment>
		);
	}
}
AnunciosPreJuego.propTypes = {
	translate: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	charging_url: PropTypes.string.isRequired,
	addata: PropTypes.shape({}).isRequired,
	onFinish: PropTypes.func.isRequired
};
AnunciosPreJuego.defaultProps = {
	translate: {
		loading: "Loading",
		loading_ads:
			"¡ Gracias por ver el anuncio ! Nos ayudas a mantener los juegos gratis",
		segundo: "segundo",
		segundos: "segundos"
	}
};
export default AnunciosPreJuego;
